module.exports = __webpack_public_path__ + "static/adult-blue-dragon-ec1cf516aea01a6f0bcaaba394b259c6.png";